import React from "react";
import { FormattedMessage } from "react-intl";

export function EmployeeScheduleUnAssignedTypesWarningText(props: {
  unAssignedTypes: number;
}) {
  const { unAssignedTypes } = props;

  return (
    <FormattedMessage
      defaultMessage="{unAssignedTypes, plural, one {one cost center is not assigned to a team} other {{unAssignedTypes} cost centers are not assigned to a team}}"
      values={{
        unAssignedTypes,
      }}
    />
  );
}
